import { TermsPolicyDataUseEntry } from '@cibo/core'
import { AuthLayout, BrandLogo, Loading, useSelfOrgContent, useWindowTitle } from '@cibo/profile'
import { FriendlyError, Markdown } from '@cibo/ui'
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const PolicyPage = () => {
  const orgContent = useSelfOrgContent()
  const { t } = useTranslation('impact/pages/PolicyPage')
  const policies =
    orgContent.data?.fields.policies ??
    ([orgContent.data?.fields.termsPolicyDataUse, orgContent.data?.fields.privacyPolicy].filter(
      Boolean
    ) as TermsPolicyDataUseEntry[])
  const { id } = useParams()
  const policy = policies.find(policy => policy.sys.id === id)
  useWindowTitle(policy?.fields.title)

  if (orgContent.isLoading) return <Loading large />

  if (orgContent.error) {
    return (
      <AuthLayout variant="content">
        <FriendlyError message={t('error')} />
      </AuthLayout>
    )
  }

  if (!policy) {
    return (
      <AuthLayout variant="content">
        <Dialog open={true} maxWidth="md" fullWidth hideBackdrop disablePortal>
          <DialogTitle>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">{t('notFoundTitle')}</Typography>
              <BrandLogo variant="square" size="large" />
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Typography>{t('notFoundBody')}</Typography>
          </DialogContent>
        </Dialog>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout variant="content">
      <Dialog open={true} maxWidth="md" fullWidth hideBackdrop disablePortal>
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{policy.fields.title}</Typography>
            <BrandLogo variant="square" size="large" />
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Markdown>
            {policy.fields.agreementMarkdownLong ?? policy.fields.agreementMarkdown}
          </Markdown>
        </DialogContent>
      </Dialog>
    </AuthLayout>
  )
}
